module.exports = __webpack_public_path__ + "img/horizontal_4_4_8004.567d9153.png";